/**
 * Позволяет ограничивать диапазон изменения некоего значения, задавая его нижний и верхний пределы
 */
export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max));
